import { devtools, subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { createStore } from "zustand/vanilla";
import type { LoginRadiusStore } from "@/ts/types";

export const initialState = {
	email: undefined,
};

export const loginRadiusStore = createStore<LoginRadiusStore>()(
	devtools(
		subscribeWithSelector(
			immer((_set, _get) => ({
				...initialState,
			})),
		),
		{
			name: "Hydra-LoginRadiusStore",
		},
	),
);
